import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";

const METRIC_KEYS = ["sore", "stress", "energy", "mood", "sleep"];

const MAX_BARS = 5;

function MetricRow({ label, value }) {
  const filled = Math.min(MAX_BARS, Math.round(value ?? 0));
  return (
    <div className="readiness-metric-row">
      <span className="readiness-metric-label">{label}</span>
      <span className="readiness-metric-bars">
        {Array.from({ length: MAX_BARS }, (_, i) => (
          <span
            key={i}
            className={`readiness-bar${i < filled ? " readiness-bar--filled" : ""}`}
          />
        ))}
      </span>
    </div>
  );
}

function LogReadinessCard({ dailyStat }) {
  const { t } = useTranslation("athlete-portal");
  const score = dailyStat?.readiness?.score ?? dailyStat?.readiness;
  if (!score && score !== 0) return null;

  const isObject = score !== null && typeof score === "object";
  const metrics = isObject ? score : null;

  const totalScore = metrics
    ? METRIC_KEYS.reduce(
        (sum, key) =>
          sum + Math.min(MAX_BARS, Math.round(metrics[key] ?? 0)),
        0
      )
    : score;
  const totalMax = metrics ? METRIC_KEYS.length * MAX_BARS : null;

  return (
    <div className="log-card log-card--readiness">
      <div className="log-card__header">
        <SvgIcon
          src="/img/new-icons/heart-circle-bolt-solid.svg"
          useCurrentColor={true}
        />
        <span>{t("calendar.cards.readiness.title")}</span>
        <span className="log-card__score-inline">
          {totalScore}
          {totalMax != null && `/${totalMax}`}
        </span>
      </div>
      {metrics && (
        <div className="log-card__body">
          {METRIC_KEYS.map((key) => (
            <MetricRow
              key={key}
              label={t(`calendar.cards.readiness.${key}`)}
              value={metrics[key]}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default LogReadinessCard;
